{
  "familyId": "GET-GROOT-SCHATTEN",
  "questions": [
    {
      "id": "GET-GROOT-SCHATTEN-001",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Een school heeft 387 leerlingen. Hoeveel leerlingen zijn dat ongeveer?",
      "options": ["ongeveer 400", "ongeveer 300", "ongeveer 350", "ongeveer 500"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "numberline", "data": {"start": 300, "end": 500, "marked": [387], "step": 100, "label": "387 op de getallenlijn tussen 300 en 500"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schatten = afronden op een handig getal", "content": "387 ligt tussen 300 en 400. Het verschil met 300 is 87, het verschil met 400 is maar 13. Dus 387 ligt dichter bij 400. Kijk naar het tientallencijfer: 8 ≥ 5, dus rond je omhoog af.", "icon": "lightbulb"}}],
      "conceptId": "schatten_honderdtallen",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "387 ligt tussen 300 en 400. Het verschil met 400 is maar 13, terwijl het verschil met 300 wel 87 is. Dus 387 ≈ 400. Kijk naar het tientallencijfer (8): dat is 5 of meer, dus je rondt omhoog af.",
        "solutionSteps": ["387 ligt tussen 300 en 400", "Verschil met 300: 87 | Verschil met 400: 13", "387 is dichter bij 400", "Antwoord: ongeveer 400"],
        "distractorExplanations": {
          "0": "Goed! 387 ligt het dichtst bij 400. Schatten = afronden op een handig getal.",
          "1": "Je dacht waarschijnlijk dat je naar beneden afrondt. Maar 387 is veel dichter bij 400 (verschil 13) dan bij 300 (verschil 87). Onthoud: kijk naar het tientallencijfer — 8 is 5 of meer, dus rond omhoog af.",
          "2": "Je dacht waarschijnlijk dat 350 een goede schatting is. 350 is niet verkeerd, maar bij schatten op honderdtallen kies je het dichtstbijzijnde honderdtal: 400. Onthoud: rond af op het dichtstbijzijnde 'ronde' getal.",
          "3": "Je dacht waarschijnlijk dat 387 dichter bij 500 ligt. Maar 387 is maar 13 verwijderd van 400 en wel 113 van 500. Onthoud: kijk altijd naar het dichtstbijzijnde honderdtal."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-002",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Je wilt 48 × 21 schatten. Welke schatting is het handigst?",
      "options": ["50 × 20 = 1.000", "48 × 20 = 960", "40 × 20 = 800", "50 × 25 = 1.250"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schatten bij vermenigvuldigen", "content": "Rond beide getallen af naar 'makkelijke' getallen. 48 ≈ 50 en 21 ≈ 20. Dan: 50 × 20 = 1.000. Het echte antwoord is 1.008, dus de schatting is heel nauwkeurig!", "icon": "lightbulb"}}],
      "conceptId": "schatten_vermenigvuldiging",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond beide getallen af naar 'makkelijke' getallen: 48 ≈ 50 en 21 ≈ 20. Dan: 50 × 20 = 1.000. Het echte antwoord is 48 × 21 = 1.008, dus de schatting is heel nauwkeurig!",
        "solutionSteps": ["Rond af: 48 ≈ 50 (dichtbij, makkelijk getal)", "Rond af: 21 ≈ 20 (dichtbij, makkelijk getal)", "Schat: 50 × 20 = 1.000", "Check: exact is 48 × 21 = 1.008 ✓"],
        "distractorExplanations": {
          "0": "Goed! 50 × 20 = 1.000 is de handigste schatting. Beide getallen zijn afgerond naar het dichtstbijzijnde tiental.",
          "1": "Je dacht waarschijnlijk dat je maar één getal hoeft af te ronden. 48 × 20 = 960 is nauwkeurig, maar niet de handigste schatting. Onthoud: bij schatten rond je beide getallen af naar makkelijke getallen, zodat je snel uit je hoofd kunt rekenen.",
          "2": "Je dacht waarschijnlijk dat 48 ≈ 40. Maar 48 is dichter bij 50 dan bij 40. Door te ver af te ronden wordt je schatting minder nauwkeurig: 800 in plaats van 1.008. Onthoud: rond af naar het dichtstbijzijnde tiental.",
          "3": "Je dacht waarschijnlijk dat 21 ≈ 25. Maar 21 is dichter bij 20 dan bij 25. 50 × 25 = 1.250 is te hoog. Onthoud: rond af naar het dichtstbijzijnde tiental, niet naar een willekeurig rond getal."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-003",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "In een stadion zitten 23.456 mensen. Hoeveel is dat afgerond op duizendtallen?",
      "options": ["23.000", "24.000", "23.500", "20.000"],
      "correctAnswer": 0,
      "stimulusAids": [{"type": "numberline", "data": {"start": 23000, "end": 24000, "marked": [23456], "step": 1000, "label": "23.456 op de getallenlijn tussen 23.000 en 24.000"}}],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Afronden op duizendtallen", "content": "Kijk naar het honderdtallencijfer (het cijfer rechts van de duizendtallen). In 23.456 is dat de 4. Is 4 kleiner dan 5? Ja → rond naar beneden af: 23.000.", "icon": "lightbulb"}}],
      "conceptId": "schatten_duizendtallen",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Kijk naar het honderdtallencijfer in 23.456: dat is de 4. Is 4 kleiner dan 5? Ja — dus rond naar beneden af. 23.456 ≈ 23.000.",
        "solutionSteps": ["Afronden op duizendtallen → kijk naar de honderdtallen", "Het honderdtallencijfer is 4", "4 < 5 → rond naar beneden af", "23.456 ≈ 23.000"],
        "distractorExplanations": {
          "0": "Goed! Het honderdtallencijfer is 4 (< 5), dus naar beneden: 23.000.",
          "1": "Je dacht waarschijnlijk dat je omhoog afrondt. Maar het honderdtallencijfer is 4, en 4 < 5, dus je rondt naar beneden af: 23.000. Onthoud: alleen bij 5 of meer rond je omhoog af.",
          "2": "Je dacht waarschijnlijk dat je op honderdtallen moet afronden. 23.500 is afgerond op honderdtallen, niet op duizendtallen. Onthoud: bij duizendtallen worden honderdtallen, tientallen en eenheden allemaal 0.",
          "3": "Je dacht waarschijnlijk dat je op tienduizendtallen moet afronden. 20.000 is te grof afgerond. Onthoud: de vraag zegt 'duizendtallen', dus je houdt de duizendtallen (23) en maakt de rest 0."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-004",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Je wilt 312 + 489 schatten. Welke schatting past het best?",
      "options": ["300 + 500 = 800", "300 + 400 = 700", "310 + 490 = 800", "350 + 500 = 850"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schatten bij optellen", "content": "Rond beide getallen af op honderdtallen. 312 ≈ 300 (tientallencijfer 1 < 5 → naar beneden). 489 ≈ 500 (tientallencijfer 8 ≥ 5 → naar boven). Dan: 300 + 500 = 800.", "icon": "lightbulb"}}],
      "conceptId": "schatten_optelling",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.69,
      "feedback": {
        "explanationText": "Rond beide getallen af op honderdtallen: 312 ≈ 300 (tientallencijfer 1 < 5, dus naar beneden) en 489 ≈ 500 (tientallencijfer 8 ≥ 5, dus naar boven). Dan: 300 + 500 = 800. Het echte antwoord is 801, dus de schatting is uitstekend!",
        "solutionSteps": ["Rond af: 312 ≈ 300 (1 < 5 → naar beneden)", "Rond af: 489 ≈ 500 (8 ≥ 5 → naar boven)", "Schat: 300 + 500 = 800", "Check: exact is 312 + 489 = 801 ✓"],
        "distractorExplanations": {
          "0": "Goed! 300 + 500 = 800 is de beste schatting. 312 ≈ 300 en 489 ≈ 500.",
          "1": "Je dacht waarschijnlijk dat 489 ≈ 400. Maar het tientallencijfer van 489 is 8, en 8 ≥ 5, dus je rondt omhoog af naar 500. Onthoud: kijk altijd naar het tientallencijfer bij afronden op honderdtallen.",
          "2": "Je dacht waarschijnlijk dat 310 + 490 = 800 de beste schatting is. Het antwoord is hetzelfde, maar bij schatten kies je de makkelijkste getallen om uit je hoofd te rekenen. Onthoud: rond af op honderdtallen, niet op tientallen.",
          "3": "Je dacht waarschijnlijk dat 312 ≈ 350. Maar 312 is dichter bij 300 (verschil 12) dan bij 350 (verschil 38). Onthoud: rond af naar het dichtstbijzijnde honderdtal."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-005",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "multiple_choice",
      "question": "Een boek heeft 196 pagina's. Je hebt er 52 gelezen. Hoeveel pagina's moet je nog ongeveer lezen?",
      "options": ["ongeveer 150", "ongeveer 100", "ongeveer 200", "ongeveer 250"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{"type": "rule", "showWhen": "wrong", "data": {"title": "Schatten in context", "content": "Rond af en reken dan. 196 ≈ 200 en 52 ≈ 50. Dan: 200 − 50 = 150. Je moet nog ongeveer 150 pagina's lezen.", "icon": "lightbulb"}}],
      "conceptId": "schatten_aftrekking_context",
      "variantIndex": 5,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Rond af en reken dan: 196 ≈ 200 en 52 ≈ 50. Dan: 200 − 50 = 150. Je moet nog ongeveer 150 pagina's lezen. Het exacte antwoord is 196 − 52 = 144, dus de schatting is goed!",
        "solutionSteps": ["Rond af: 196 ≈ 200 (dichtbij, makkelijk getal)", "Rond af: 52 ≈ 50 (dichtbij, makkelijk getal)", "Schat: 200 − 50 = 150", "Check: exact is 196 − 52 = 144 ✓"],
        "distractorExplanations": {
          "0": "Goed! 200 − 50 = 150. De schatting is dicht bij het exacte antwoord (144).",
          "1": "Je dacht waarschijnlijk dat het verschil kleiner is. Maar 196 − 52 is veel meer dan 100. Reken: 200 − 50 = 150. Onthoud: rond beide getallen af en reken dan het verschil uit.",
          "2": "Je dacht waarschijnlijk dat je bijna het hele boek nog moet lezen. Maar je hebt al 52 pagina's gelezen, dus je hoeft niet meer bijna 200 te lezen. Onthoud: trek het aantal gelezen pagina's af van het totaal.",
          "3": "Je dacht waarschijnlijk dat het boek meer pagina's heeft. Maar het boek heeft 196 pagina's — je kunt nooit meer dan 196 pagina's over hebben. Onthoud: het antwoord kan nooit groter zijn dan het totaal aantal pagina's."
        }
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-009",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "estimation_slider",
      "question": "Schat: waar hoort 347 op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 1000,
        "correctValue": 347,
        "tolerancePercent": 10,
        "showNumberLine": true,
        "showValue": false
      },
      "conceptId": "schatten_slider_1000",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "347 ligt ongeveer op een derde van de lijn tussen 0 en 1000. Het is iets minder dan de helft (500).",
        "solutionSteps": ["Kijk naar de getallenlijn van 0 tot 1000", "De helft is 500", "347 is minder dan 500, maar meer dan 250 (een kwart)", "Plaats de schuif op ongeveer een derde van de lijn"]
      }
    },
    {
      "id": "GET-GROOT-SCHATTEN-010",
      "familyId": "GET-GROOT-SCHATTEN",
      "module": "Getalbegrip",
      "tier": 7,
      "levelCode": "B7",
      "group": 7,
      "skill": "positiestelsel",
      "subSkill": "groot_schatten",
      "questionType": "estimation_slider",
      "question": "Schat: waar hoort 4.500 op de getallenlijn?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "min": 0,
        "max": 10000,
        "correctValue": 4500,
        "tolerancePercent": 10,
        "showNumberLine": true,
        "showValue": false
      },
      "conceptId": "schatten_slider_10000",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "4.500 ligt net iets voor het midden van de lijn tussen 0 en 10.000. Het midden is 5.000.",
        "solutionSteps": [
          "Kijk naar de getallenlijn van 0 tot 10.000",
          "De helft is 5.000",
          "4.500 is iets minder dan 5.000",
          "Plaats de schuif net voor het midden"
        ]
      }
    }
  ]
}